import React, { useRef, useEffect } from "react";
import { initLuxuryMotion } from "../utils/animations";

/* ═══════════════════════════════════════════════════════════
   SECTION WRAPPER — Luxury Motion Scope
   Each section gets its own GSAP scope for clean lifecycle
   ═══════════════════════════════════════════════════════════ */

const Section = ({ id = "", className = "", children }) => {
  const ref = useRef(null);

  useEffect(() => {
    const cleanup = initLuxuryMotion(ref.current);
    return cleanup;
  }, []);

  return (
    <section
      id={id}
      ref={ref}
      className={`lux-section ${className}`}
    >
      {children}
    </section>
  );
};

export default Section;